export default __webpack_public_path__ + "static/media/IBimageScissors1.4d2b0f5a.png";